import PropTypes from 'prop-types';
import React from 'react';

const CPlusplus = ({ className }) => (
  <svg
    className={className}
    width="1731"
    height="857"
    viewBox="0 0 1731 857"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.08" cx="212" cy="216" r="124" fill="url(#paint0_linear_1112_9467)" />
    <circle opacity="0.08" cx="212" cy="216" r="104" fill="url(#paint1_linear_1112_9467)" />
    <mask
      id="mask0_1112_9467"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="108"
      y="112"
      width="208"
      height="208"
    >
      <circle cx="212" cy="216" r="104" fill="#181A1B" />
    </mask>
    <g mask="url(#mask0_1112_9467)">
      <g opacity="0.8">
        <path
          d="M386.83 -138.5L319.57 -99.67L308.25 -93.13L296.6 -86.41L285.14 -79.79L273.57 -73.11L261.77 -66.3L250.2 -59.62L238.86 -53.07L227.29 -46.39L215.67 -39.68L204 -33L192.41 -26.31L180.81 -19.62L169.23 -12.92C165.36 -10.7 161.5 -8.46001 157.64 -6.24001L146.06 0.449997L134.48 7.14L122.9 13.82L111.31 20.51L99.74 27.19L88.15 33.88L76.59 40.56L65 47.29L53.46 54L41.88 60.68L30.3 67.37L18.74 74L7.14999 80.69L-4.42 87.38C-8.28 89.6 -12.14 91.84 -16.01 94.06L-27.58 100.75L-39.16 107.43L-50.74 114.12L-62.31 120.8L-73.9 127.5L-85.48 134.19L-97.06 140.87L-108.65 147.56L-120.23 154.25L-131.83 160.94L-143.43 167.64L-149.5 171.14"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M452.41 -138.5L352.41 -80.74L341 -74.2L329.35 -67.47L317.89 -60.86L306.32 -54.18L294.52 -47.37L283 -40.69L271.65 -34.14L260.08 -27.46L248.46 -20.75L236.82 -14L225.23 -7.31L213.63 -0.610001L202.05 6.08L190.46 12.76C186.6 15 182.74 17.23 178.88 19.45L167.3 26.14L155.72 32.82L144.13 39.51L132.56 46.19L121 52.85L109.43 59.53L97.85 66.22L86.28 72.9C82.42 75.1267 78.5567 77.3533 74.69 79.58L63.11 86.27L51.53 93L39.94 99.69L28.37 106.37L16.79 113L5.21001 119.68L-6.37 126.37L-17.95 133.05L-29.52 139.73L-41.1 146.42C-44.96 148.653 -48.8233 150.88 -52.69 153.1L-64.27 159.8L-75.85 166.49L-87.44 173.19L-99 179.88L-110.6 186.57L-122.2 193.26C-126.1 195.5 -129.96 197.71 -133.78 199.7C-137.515 201.708 -141.4 203.423 -145.4 204.83C-146.745 205.291 -148.114 205.682 -149.5 206"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M536.439 267.37L526.069 273.37L514.479 280L502.919 286.68L491.329 293.37L479.769 300.05C475.899 302.27 472.049 304.5 468.179 306.74L456.599 313.42L444.999 320.14L433.409 326.83L421.839 333.51L410.249 340.2L398.679 346.87C394.819 349.09 390.959 351.283 387.099 353.45C383.239 355.6 379.379 357.69 375.519 359.79C371.659 361.89 367.849 364 363.999 366C360.149 368 356.289 369.9 352.419 371.87C348.549 373.84 344.709 375.87 340.839 377.87C336.969 379.87 333.119 381.87 329.259 384.01C325.399 386.15 321.529 388.28 317.669 390.51C313.809 392.74 309.939 395.05 306.079 397.44C302.219 399.83 298.339 402.33 294.489 404.83L282.889 412.36C278.989 414.89 275.119 417.36 271.279 419.81C267.439 422.26 263.529 424.57 259.709 426.86C255.889 429.15 251.949 431.52 248.119 433.78C244.289 436.04 240.329 438.33 236.509 440.53L224.999 447.18L213.499 453.82L201.999 460.48L190.269 467.25C186.383 469.49 182.536 471.71 178.729 473.91L167.279 480.52L155.709 487.2L143.999 493.93L132.299 500.69C128.393 502.95 124.479 505.207 120.559 507.46L109.359 513.93L51.3594 547.44"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M536.442 229.5L528.002 234.36L516.422 241.05L504.832 247.74L493.252 254.42L481.672 261.11L470.102 267.79L458.522 274.48L447.002 281.16L435.422 287.84L423.842 294.53L412.282 301.19C408.408 303.423 404.542 305.63 400.682 307.81C396.832 309.98 392.982 312.11 389.112 314.09C385.242 316.07 381.392 317.85 377.532 319.44C370.146 322.609 362.354 324.732 354.382 325.75C350.522 326.29 346.662 326.66 342.792 326.89C338.922 327.12 335.092 327.22 331.222 327.52C327.331 327.802 323.462 328.34 319.642 329.13C315.694 329.959 311.806 331.048 308.002 332.39C304.054 333.793 300.185 335.409 296.412 337.23C292.562 339.1 288.692 341.23 284.832 343.51C280.972 345.79 277.102 348.28 273.242 351.03C269.382 353.78 265.502 356.85 261.642 360.24C257.782 363.63 253.902 367.41 250.052 371.39C246.202 375.37 242.282 379.68 238.442 384.02C234.602 388.36 230.692 392.92 226.862 397.11C223.032 401.3 219.112 405.32 215.282 408.96C211.452 412.6 207.482 416.07 203.672 419.13C199.862 422.19 195.972 425.04 192.172 427.59C188.372 430.14 184.522 432.49 180.672 434.79C176.822 437.09 173.062 439.27 169.152 441.53C165.242 443.79 161.322 446.06 157.422 448.31L145.912 455L134.462 461.61L122.892 468.29L111.232 475L99.5317 481.75L87.7917 488.53L76.5917 495L-14.2383 547.45"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M536.44 51.7098L535.9 51.5098C532.15 50.0226 528.033 49.7293 524.11 50.6698C520.11 51.7198 516.3 54.2998 512.54 58.3198C508.78 62.3398 505 67.9998 501.2 74.0698C497.4 80.1398 493.57 86.6798 489.63 92.6198C486.175 97.933 482.285 102.95 478 107.62C474.471 111.358 470.575 114.731 466.37 117.69C462.52 120.44 458.65 122.78 454.77 125.08C450.89 127.38 447.05 129.59 443.18 131.83L431.59 138.53L420 145.27L408.43 152L396.85 158.68C392.98 160.91 389.13 163.14 385.26 165.36C381.39 167.58 377.53 169.79 373.68 171.92C369.83 174.05 366 176 362.11 177.78C358.41 179.545 354.522 180.887 350.52 181.78C346.714 182.538 342.811 182.68 338.96 182.2C335.022 181.681 331.142 180.793 327.37 179.55C323.595 178.201 319.728 177.121 315.8 176.32C311.937 175.662 307.974 175.905 304.22 177.03C299.966 178.389 296.028 180.589 292.64 183.5C288.373 187.161 284.496 191.252 281.07 195.71C277.22 200.57 273.35 206.1 269.49 211.71C265.63 217.32 261.78 222.98 257.92 227.92C254.36 232.486 250.488 236.8 246.33 240.83C242.685 244.381 238.82 247.701 234.76 250.77C230.9 253.68 227.04 256.21 223.18 258.62C219.32 261.03 215.46 263.3 211.6 265.55C207.74 267.8 203.88 270 200 272.27L188.44 279L176.86 285.69L165.28 292.37L153.69 299C149.83 301.233 145.967 303.463 142.1 305.69C138.23 307.93 134.36 310.18 130.51 312.25C126.768 314.308 122.892 316.116 118.91 317.66C115.223 319.177 111.286 319.997 107.3 320.08L106.16 320.03"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M536.44 305.23L535.71 305.66L524.13 312.34L512.56 319L501 325.71L489.41 332.39L477.85 339.07L466.26 345.76L454.69 352.44L443.11 359.13L431.53 365.81L419.95 372.5L408.37 379.19L396.79 385.86L385.21 392.55L373.64 399.23L362 405.92L350.42 412.61L338.82 419.3L327.26 426L315.66 432.69L304.05 439.4L292.48 446.09L280.9 452.77C276.98 455.03 273.1 457.28 269.28 459.47L257.78 466.11L246.29 472.76C242.49 474.94 238.67 477.15 234.76 479.41L223 486.18L211.46 492.84L200 499.45L188.44 506.13L176.78 512.86L165.07 519.62L153.33 526.4L142.13 532.86L118.82 546.32"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M536.439 92.1499L533.989 96.1499C530.229 102.35 526.369 108.74 522.419 114.26C518.978 119.142 515.084 123.689 510.789 127.84C507.189 131.228 503.297 134.293 499.159 137C495.309 139.57 491.439 141.81 487.559 144.07L475.999 150.82L464.409 157.51L452.829 164.19C448.969 166.43 445.109 168.66 441.249 170.88L429.669 177.57L418.089 184.25L406.499 190.94L394.929 197.61C391.059 199.83 387.199 202.04 383.339 204.13C379.479 206.22 375.629 208.22 371.779 209.94C368.061 211.686 364.179 213.059 360.189 214.04C356.401 214.925 352.499 215.228 348.619 214.94C344.69 214.578 340.802 213.865 336.999 212.81C333.129 211.81 329.269 210.73 325.409 210.07C321.595 209.31 317.671 209.29 313.849 210.01C309.659 211.009 305.716 212.849 302.259 215.42C297.993 218.54 294.11 222.151 290.689 226.18C286.829 230.59 282.969 235.82 279.099 241.25C275.229 246.68 271.389 252.31 267.529 257.44C263.942 262.258 260.093 266.875 255.999 271.27C252.373 275.106 248.505 278.707 244.419 282.05C240.706 285.081 236.841 287.921 232.839 290.56C228.989 293.13 225.129 295.48 221.259 297.78C217.389 300.08 213.549 302.32 209.689 304.56L198.099 311.26L186.479 318C182.619 320.23 178.759 322.46 174.889 324.62C171.019 326.78 167.159 328.88 163.299 330.57C159.61 332.27 155.713 333.48 151.709 334.17C150.919 334.29 150.139 334.37 149.359 334.43"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M536.441 153.17C534.951 154.17 533.441 155.17 531.961 156.09C528.101 158.52 524.231 160.78 520.361 163.09L508.761 169.8L497.171 176.49L485.591 183.18L474.001 189.82L462.431 196.5L450.841 203.19L439.261 209.88L427.681 216.55L416.091 223.25L404.531 229.92C400.671 232.15 396.801 234.39 392.941 236.52C389.081 238.65 385.231 240.66 381.371 242.52C377.631 244.351 373.764 245.912 369.801 247.19C366.054 248.396 362.156 249.069 358.221 249.19C354.325 249.172 350.444 248.716 346.651 247.83C342.791 247 338.921 245.95 335.061 245.13C331.283 244.191 327.389 243.81 323.501 244C319.44 244.415 315.502 245.628 311.911 247.57C307.713 249.823 303.824 252.61 300.341 255.86C296.187 259.755 292.317 263.942 288.761 268.39C284.911 273.11 281.041 278.29 277.181 283.39C273.321 288.49 269.471 293.57 265.601 298.15C261.953 302.483 258.082 306.622 254.001 310.55C250.32 314.1 246.458 317.458 242.431 320.61C238.571 323.61 234.711 326.29 230.841 328.75C226.971 331.21 223.121 333.43 219.251 335.54C215.492 337.646 211.623 339.549 207.661 341.24L206.711 341.63"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M501.091 35.2701C498.014 33.9139 494.683 33.232 491.321 33.2701C487.321 33.4601 483.511 35.2701 479.751 38.3301C475.991 41.3901 472.221 45.9501 468.401 51.5201C464.581 57.0901 460.781 63.5201 456.831 69.7601C453.3 75.5379 449.419 81.0949 445.211 86.4001C441.734 90.6453 437.834 94.5254 433.571 97.9801C429.89 100.919 426.025 103.621 422.001 106.07C418.141 108.48 414.271 110.7 410.411 112.94L398.821 119.64L387.241 126.33L375.641 133C371.771 135.21 367.921 137.41 364.061 139.54C360.201 141.67 356.331 143.76 352.471 145.47C348.744 147.145 344.867 148.464 340.891 149.41C337.105 150.314 333.209 150.674 329.321 150.48C325.374 150.16 321.481 149.354 317.731 148.08C313.871 146.83 310.011 145.25 306.161 144.51C302.32 143.748 298.353 143.898 294.581 144.95C290.33 146.209 286.386 148.337 283.001 151.2C278.707 154.839 274.824 158.936 271.421 163.42C267.561 168.32 263.701 173.94 259.831 179.67C255.961 185.4 252.131 191.21 248.271 196.23C244.742 200.822 240.868 205.138 236.681 209.14C233.052 212.633 229.186 215.871 225.111 218.83C221.261 221.64 217.401 224.06 213.531 226.4C209.661 228.74 205.831 231 202.001 233.27L190.391 240L178.801 246.69L167.231 253.37L155.651 260L144.071 266.68L132.481 273.37L120.901 280.06L109.311 286.75L97.7211 293.41C93.8311 295.64 89.9711 297.84 86.1211 299.75C82.4444 301.676 78.5453 303.144 74.5111 304.12C70.8433 304.926 67.046 304.944 63.3711 304.17"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M401.238 12.4799C397.842 12.3968 394.458 12.9078 391.238 13.9899C387.117 15.4376 383.209 17.4321 379.618 19.9199C375.539 22.6995 371.657 25.7567 367.998 29.0699C364.148 32.5099 360.278 36.3199 356.408 39.8299C352.723 43.1964 348.85 46.3514 344.808 49.2799C341.151 51.9379 337.273 54.2797 333.218 56.2799C329.476 58.0804 325.605 59.6013 321.638 60.8299C317.768 62.0599 313.918 63.0799 310.058 64.1499C306.198 65.2199 302.338 66.3399 298.478 67.7599C294.494 69.2249 290.62 70.9762 286.888 72.9999C282.851 75.203 278.98 77.6997 275.308 80.4699C271.206 83.5735 267.336 86.9726 263.728 90.6399C259.636 94.8302 255.768 99.2329 252.138 103.83C248.278 108.65 244.428 113.83 240.578 118.83C236.728 123.83 232.848 128.66 228.988 133.06C225.373 137.242 221.509 141.202 217.418 144.92C213.74 148.18 209.877 151.225 205.848 154.04C201.988 156.78 198.118 159.31 194.258 161.71C190.398 164.11 186.558 166.38 182.698 168.64L171.108 175.35L159.538 182.03L147.998 188.74L136.428 195.42L124.848 202.11L113.268 208.79C109.408 211.01 105.552 213.24 101.698 215.48L90.1083 222.16L78.5283 228.85L66.9483 235.54L55.3583 242.22L43.7783 248.91L32.1783 255.6C28.2983 257.84 24.4283 260.07 20.5883 262.25C16.7483 264.43 12.8083 266.63 8.97827 268.38C5.31759 270.165 1.41676 271.408 -2.60173 272.07C-5.9924 272.538 -9.44139 272.351 -12.7617 271.52"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M536.44 -111.28L418 -42.8698L406.67 -36.3398L395 -29.6098L383.51 -22.9998L371.94 -16.3198L360.15 -9.51979L348.59 -2.83978L337.24 3.65021C333.48 5.78021 329.62 7.97022 325.67 10.1302C321.72 12.2902 318 14.2902 314 16.4002C310 18.5102 306.27 20.5602 302.37 22.6102C298.47 24.6602 294.65 26.6102 290.77 28.6802C286.89 30.7502 283.05 32.8202 279.18 34.9802C275.31 37.1402 271.45 39.3702 267.59 41.6802C263.73 43.9902 259.87 46.3802 256.01 48.8002C252.15 51.2202 248.28 53.6502 244.43 56.0802C240.58 58.5102 236.7 60.9102 232.85 63.3002C229 65.6902 225.12 68.0202 221.26 70.3002C217.4 72.5802 213.53 74.9402 209.68 77.2102C205.83 79.4802 202 81.7902 198.15 84.0002L186.56 90.6902L175 97.3902L163.41 104.08L151.84 110.77L140.26 117.45L128.68 124.14C124.82 126.36 120.98 128.59 117.11 130.81L105.53 137.5L94 144.18L82.41 150.87L70.83 157.56L59.26 164.24L47.68 170.93L36.1 177.61L24.52 184.3L12.9 191L1.32001 197.69L-10.27 204.38L-21.86 211.07L-33.45 217.76L-45 224.43C-48.9 226.69 -52.78 228.94 -56.61 231.04C-60.44 233.14 -64.36 235.19 -68.18 236.82C-71.8532 238.505 -75.7612 239.621 -79.77 240.13C-82.5275 240.401 -85.3109 240.198 -88 239.53"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-149.5 211.89C-143.98 214.52 -138.38 217.06 -132.81 219.56C-126.32 222.48 -119.81 225.36 -113.29 228.25C-107.29 230.93 -101.2 233.6 -95.17 236.32C-92.17 237.67 -89.17 239.03 -86.17 240.37C-83.17 241.71 -80.08 243.06 -77.02 244.37L-68.1 248.16L-58.81 252.16C-55.7433 253.493 -52.67 254.79 -49.59 256.05C-46.59 257.32 -43.51 258.56 -40.47 259.82C-37.43 261.08 -34.3 262.38 -31.22 263.68C-28.14 264.98 -25.22 266.27 -22.22 267.56C-19.02 268.94 -15.8133 270.307 -12.6 271.66C-9.70001 272.88 -6.8 274.09 -3.92 275.34C-1.04 276.59 1.54 277.74 4.27 278.96C7.42 280.37 10.6 281.77 13.77 283.15L23.09 287.15L32.41 291.24C35.5167 292.573 38.6333 293.907 41.76 295.24C44.7 296.5 47.6467 297.747 50.6 298.98L55.21 300.98C56.65 301.58 58.08 302.19 59.53 302.75L61.78 303.6L64.22 304.52L69.12 306.35L78.71 309.94C81.77 311.09 84.84 312.26 87.9 313.39C90.96 314.52 93.9 315.62 96.9 316.7L106.35 320.08C109.5 321.21 112.65 322.36 115.8 323.48C118.95 324.6 122.17 325.74 125.37 326.83C128.57 327.92 131.65 328.94 134.8 329.97C137.95 331 140.87 331.97 143.92 332.87"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M518 -138.5L385.15 -61.81L373.83 -55.27L362.18 -48.54L350.72 -41.92L339.15 -35.25L327.36 -28.43L315.79 -21.76L304.44 -15.21L292.88 -8.53L281.25 -1.82001L269.61 4.89999L258 11.59L246.41 18.29C242.537 20.51 238.673 22.74 234.82 24.98L223.24 31.67C219.37 33.89 215.51 36.13 211.66 38.35L200.09 45L188.51 51.69L176.93 58.38C173.057 60.6 169.2 62.8233 165.36 65.05L153.77 71.75L142.21 78.42L130.62 85.11L119.05 91.79L107.47 98.48L95.8898 105.16L84.3199 111.84L72.7298 118.53L61.1698 125.21L49.5798 131.9L37.9998 138.62L26.4298 145.31L14.8499 152L3.26985 158.69L-8.31015 165.37L-19.8902 172.06C-23.7502 174.28 -27.6102 176.51 -31.4702 178.75C-35.3302 180.99 -39.1935 183.22 -43.0602 185.44L-54.6502 192.13L-66.2402 198.82L-77.8402 205.52L-89.4502 212.19C-93.3502 214.43 -97.2102 216.63 -101.03 218.52C-104.71 220.442 -108.595 221.945 -112.61 223C-116.408 223.984 -120.382 224.073 -124.22 223.26C-124.54 223.19 -124.85 223.11 -125.16 223.02"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-50.4883 255.63C-49.3514 255.92 -48.195 256.127 -47.0283 256.25C-43.1061 256.547 -39.1642 256.051 -35.4383 254.79C-31.4436 253.487 -27.5718 251.834 -23.8683 249.85C-20.0283 247.85 -16.1483 245.61 -12.2483 243.35C-8.34828 241.09 -4.53829 238.91 -0.658287 236.68L10.9317 229.98L22.5217 223.29L34.1117 216.6L45.6917 209.91L57.2717 203.23L68.8517 196.54L80.4317 189.86L92.0017 183.18L103.582 176.48L115.152 169.81C119.012 167.57 122.875 165.34 126.742 163.12L138.312 156.44C142.172 154.2 146.035 151.97 149.902 149.75L161.462 143.07L173.052 136.37C176.902 134.14 180.772 131.91 184.622 129.63C188.472 127.35 192.332 125.03 196.192 122.63C200.052 120.23 203.922 117.76 207.782 115.14C211.642 112.52 215.482 109.78 219.342 106.84C223.202 103.9 227.062 100.77 230.932 97.3799C234.802 93.9899 238.642 90.3799 242.512 86.6399C246.382 82.8999 250.222 79.0499 254.092 75.2399C257.962 71.4299 261.812 67.6599 265.672 63.7899C269.532 59.9199 273.392 55.9699 277.252 52.3699C281.112 48.7699 284.962 45.5599 288.832 42.4999C292.702 39.4399 296.552 36.5699 300.412 34.0199C304.143 31.5688 308.013 29.3351 312.002 27.3299C315.522 25.5251 319.157 23.9517 322.882 22.6199L324.112 22.1899C327.112 21.1899 330.212 20.1899 333.272 19.3799C336.332 18.5699 339.192 17.8699 342.122 17.2399C344.012 16.8499 345.932 16.4699 347.822 16.1399C352.062 15.3799 356.402 14.7399 360.822 14.2599C363.152 14.0099 365.402 13.7999 367.732 13.6299C370.442 13.4399 373.212 13.2799 375.922 13.1499H376.332L378.092 13.0799C378.672 13.0799 379.252 13.0199 379.832 12.9899L381.602 12.9099C384.692 12.7699 387.932 12.6299 391.032 12.5399C394.132 12.4499 397.032 12.4299 399.972 12.4799C401.532 12.4799 403.082 12.5599 404.632 12.6299C407.432 12.7599 410.262 12.9699 413.052 13.2199C415.842 13.4699 418.442 13.7399 421.102 14.0399C424.262 14.3999 427.382 14.7999 430.512 15.2299C433.802 15.6999 437.222 16.2299 440.512 16.7799C445.732 17.6799 451.442 18.7799 456.732 20.0499"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M536.441 51.4799C531.991 49.4799 519.711 43.5599 507.441 38.0699L506.091 37.4699L502.541 35.8999H502.431L501.891 35.6599C498.417 34.1532 494.927 32.6999 491.421 31.2999C486.221 29.2332 480.971 27.3232 475.671 25.5699C471.191 24.0899 466.321 22.5699 461.671 21.3199L458.671 20.5499L456.871 20.1199C453.62 19.2601 450.215 19.1643 446.921 19.8399C442.676 20.9176 438.772 23.0502 435.571 26.0399C431.239 29.9923 427.359 34.4127 424.001 39.2199C420.201 44.4699 416.321 50.5999 412.381 56.2199C408.541 61.7199 404.651 66.7899 400.741 71.3699C397.161 75.6344 393.288 79.6441 389.151 83.3699C385.493 86.5533 381.617 89.4771 377.551 92.1199C373.691 94.6599 369.831 96.9599 365.971 99.1199C362.111 101.28 358.241 103.12 354.381 104.9C350.61 106.661 346.744 108.21 342.801 109.54C339.021 110.758 335.148 111.668 331.221 112.26C327.391 112.871 323.518 113.165 319.641 113.14C315.763 113.071 311.893 112.737 308.061 112.14C304.235 111.44 300.366 110.999 296.481 110.82C292.536 110.829 288.62 111.505 284.901 112.82C280.733 114.206 276.833 116.296 273.371 119C269.068 122.547 265.183 126.573 261.791 131C257.921 135.86 254.071 141.45 250.221 147.05C246.371 152.65 242.501 158.25 238.641 163.24C235.078 167.892 231.206 172.298 227.051 176.43C223.439 179.999 219.576 183.304 215.491 186.32C211.631 189.17 207.761 191.65 203.901 194.03C200.041 196.41 196.191 198.67 192.331 200.93C188.471 203.19 184.611 205.41 180.741 207.64L169.181 214.32L157.591 221L146.001 227.73L134.431 234.4L122.851 241.09L111.261 247.78C107.414 250.013 103.554 252.24 99.6808 254.46C95.8074 256.68 91.9441 258.91 88.0908 261.15L76.5108 267.85L64.9108 274.54C61.0308 276.78 57.1608 279.02 53.3208 281.09C49.5917 283.181 45.7108 284.99 41.7108 286.5C38.0196 287.93 34.0888 288.639 30.1308 288.59C28.1588 288.506 26.2029 288.197 24.3008 287.67"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-145.391 547.44L10.9994 457.13L22.1894 450.66L33.9294 443.89L45.6394 437.13L57.2994 430.4L68.8594 423.72C72.7294 421.48 76.5094 419.3 80.3094 417.04C84.1094 414.78 87.9594 412.42 91.8494 409.71C96.0257 406.85 99.9499 403.638 103.579 400.11C107.817 395.861 111.672 391.246 115.099 386.32C118.949 380.88 122.769 374.66 126.599 368.48C130.093 362.589 133.937 356.912 138.109 351.48C141.331 347.325 145.266 343.777 149.729 341C153.2 338.825 157.213 337.671 161.309 337.67C162.767 337.712 164.216 337.893 165.639 338.21C167.199 338.53 168.769 338.84 170.389 339.14C173.389 339.69 176.389 340.14 179.389 340.55C181.609 340.82 183.859 341.05 186.119 341.22C188.379 341.39 190.639 341.54 192.959 341.64C195.119 341.73 197.219 341.79 199.399 341.81C203.209 341.81 206.869 341.71 210.659 341.43C213.449 341.22 216.139 340.95 218.849 340.62C221.769 340.28 224.639 339.86 227.329 339.39L228.569 339.17C231.049 338.71 233.519 338.17 235.819 337.61C238.119 337.05 240.239 336.43 242.079 335.83C243.639 335.32 245.079 334.78 246.229 334.34L247.739 333.71C249.489 332.94 250.739 332.32 252.069 331.64C256.125 329.484 260 327.006 263.659 324.23C267.529 321.34 271.389 318.07 275.249 314.58C279.109 311.09 282.969 307.36 286.829 303.81C290.689 300.26 294.559 296.88 298.409 293.94C302.048 291.114 305.926 288.612 309.999 286.46C313.651 284.522 317.545 283.082 321.579 282.18C325.39 281.395 329.294 281.169 333.169 281.51C337.029 281.83 340.879 282.61 344.729 283.27C348.562 283.968 352.432 284.442 356.319 284.69C360.187 284.953 364.072 284.744 367.889 284.07C371.86 283.265 375.742 282.073 379.479 280.51C383.339 278.97 387.196 277.213 391.049 275.24C394.899 273.24 398.769 271.07 402.629 268.86C406.489 266.65 410.349 264.44 414.209 262.22L425.769 255.55L437.359 248.86L448.929 242.18L460.509 235.49L472.089 228.81L483.669 222.12L495.259 215.43L506.829 208.75L518.409 202.06L529.999 195.37L536.469 191.63"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M321.24 -138.5L286.78 -118.61L275.45 -112.06L263.81 -105.34L252.35 -98.72L240.77 -92L229 -85.23L217.43 -78.55C213.62 -76.36 209.91 -74.21 206.09 -72L194.5 -65.33L182.88 -58.62L171.24 -51.9L159.64 -45.2L148.05 -38.51L136.46 -31.82L124.88 -25.13L113.29 -18.44L101.72 -11.76L90.14 -5.07001L78.55 1.62L67 8.3L55.39 15L43.82 21.67C39.94 23.89 36.08 26.1167 32.24 28.35L20.67 35L9.09 41.69L-2.49001 48.38L-14 55.08L-25.59 61.77L-37.17 68.46L-48.75 75.14L-60.32 81.82L-72 88.51L-83.57 95.19L-95.15 101.88L-106.73 108.56L-118.31 115.25L-129.89 121.94L-141.44 128.63L-149.5 133.28"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="20"
      fontWeight="800"
      letterSpacing="0em"
    >
      <tspan x="200.053" y="159">
        IO
      </tspan>
    </text>
    <text
      fill="url(#paint2_linear_1112_9467)"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="76"
      fontWeight="800"
      letterSpacing="0em"
    >
      <tspan x="139.248" y="232.6">
        31%
      </tspan>
    </text>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="18"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="173.195" y="263.8">
        Address:&#10;
      </tspan>
      <tspan x="168.256" y="286.8">
        0x4553e0
      </tspan>
    </text>
    <g filter="url(#filter0_ddd_1112_9467)">
      <rect x="392" y="92" width="800" height="556" rx="12" fill="white" />
    </g>
    <rect opacity="0.1" x="392" y="417" width="800" height="24" fill="#FD0054" />
    <g clipPath="url(#clip0_1112_9467)">
      <path
        d="M1167.16 610C1167.68 609.13 1168 608.15 1168 607.271V576.729C1168 575.849 1167.68 574.87 1167.16 574L1135 592L1167.16 610Z"
        fill="#00599C"
      />
      <path
        d="M1137.86 627.34L1165.14 612.069C1165.93 611.629 1166.64 610.87 1167.16 610L1135 592L1102.84 610C1103.36 610.87 1104.07 611.63 1104.86 612.069L1132.14 627.34C1133.71 628.22 1136.29 628.22 1137.86 627.34Z"
        fill="#004482"
      />
      <path
        d="M1167.16 574C1166.64 573.13 1165.93 572.37 1165.14 571.931L1137.86 556.66C1136.29 555.78 1133.71 555.78 1132.14 556.66L1104.86 571.931C1103.29 572.81 1102 574.97 1102 576.729V607.271C1102 608.15 1102.32 609.13 1102.84 610L1135 592L1167.16 574Z"
        fill="#659AD2"
      />
      <path
        d="M1135 613.327C1122.87 613.327 1113 603.76 1113 592C1113 580.24 1122.87 570.673 1135 570.673C1142.83 570.673 1150.13 574.756 1154.05 581.33L1144.53 586.671C1142.57 583.38 1138.91 581.336 1135 581.336C1128.93 581.336 1124 586.12 1124 592C1124 597.88 1128.93 602.664 1135 602.664C1138.92 602.664 1142.57 600.619 1144.53 597.329L1154.05 602.669C1150.13 609.243 1142.83 613.327 1135 613.327Z"
        fill="white"
      />
      <path
        d="M1157 590.815H1154.55V588.445H1152.11V590.815H1149.66V593.185H1152.11V595.554H1154.55V593.185H1157V590.815Z"
        fill="white"
      />
      <path
        d="M1166.17 590.815H1163.72V588.445H1161.28V590.815H1158.84V593.185H1161.28V595.554H1163.72V593.185H1166.17V590.815Z"
        fill="white"
      />
    </g>
    <rect opacity="0.1" x="441" y="129" width="1" height="519" fill="#181A1B" />
    <text
      opacity="0.6"
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="408.184" y="160.938">
        14&#10;
      </tspan>
      <tspan x="408.184" y="181.938">
        15&#10;
      </tspan>
      <tspan x="408.184" y="202.938">
        16&#10;
      </tspan>
      <tspan x="408.184" y="223.938">
        17&#10;
      </tspan>
      <tspan x="408.184" y="244.938">
        18&#10;
      </tspan>
      <tspan x="408.184" y="265.938">
        19&#10;
      </tspan>
      <tspan x="408.184" y="286.938">
        20&#10;
      </tspan>
      <tspan x="408.184" y="307.938">
        21&#10;
      </tspan>
      <tspan x="408.184" y="328.938">
        22&#10;
      </tspan>
      <tspan x="408.184" y="349.938">
        23&#10;
      </tspan>
      <tspan x="408.184" y="370.938">
        24&#10;
      </tspan>
      <tspan x="408.184" y="391.938">
        25&#10;
      </tspan>
      <tspan x="408.184" y="412.938">
        26&#10;
      </tspan>
      <tspan x="408.184" y="433.938">
        27&#10;
      </tspan>
      <tspan x="408.184" y="454.938">
        28&#10;
      </tspan>
      <tspan x="408.184" y="475.938">
        29&#10;
      </tspan>
      <tspan x="408.184" y="496.938">
        30&#10;
      </tspan>
      <tspan x="408.184" y="517.938">
        31&#10;
      </tspan>
      <tspan x="408.184" y="538.938">
        32&#10;
      </tspan>
      <tspan x="408.184" y="559.938">
        33&#10;
      </tspan>
      <tspan x="408.184" y="580.938">
        34&#10;
      </tspan>
      <tspan x="408.184" y="601.938">
        35&#10;
      </tspan>
      <tspan x="408.184" y="622.938">
        36
      </tspan>
    </text>
    <path
      d="M392 104C392 97.3726 397.373 92 404 92H1180C1186.63 92 1192 97.3726 1192 104V128H392V104Z"
      fill="white"
    />
    <circle cx="414" cy="110" r="6" fill="#FD0054" />
    <circle cx="434" cy="110" r="6" fill="#FFB31A" />
    <circle cx="454" cy="110" r="6" fill="#00CC21" />
    <rect opacity="0.1" x="392" y="128" width="800" height="1" fill="#181A1B" />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="533.266" y="160.938">
        {' '}
        &#60;
      </tspan>
      <tspan x="600.531" y="160.938">
        {' '}
        n&#62;&#10;
      </tspan>
      <tspan x="499.633" y="181.938">
        {' '}
      </tspan>
      <tspan x="558.49" y="181.938">
        (
      </tspan>
      <tspan x="608.939" y="181.938">
        {' '}
        std::array&#60;std::array&#60;
      </tspan>
      <tspan x="827.553" y="181.938">
        , n&#62;, n&#62; &#38;board,{' '}
      </tspan>
      <tspan x="1046.17" y="181.938">
        {' '}
        &#38;row,&#10;
      </tspan>
      <tspan x="466" y="202.938">
        {' '}
      </tspan>
      <tspan x="642.572" y="202.938">
        {' '}
        &#38;col) {'{'}&#10;
      </tspan>
      <tspan x="466" y="223.938">
        {' '}
      </tspan>
      <tspan x="524.857" y="223.938">
        {' '}
        i ={' '}
      </tspan>
      <tspan x="575.307" y="223.938">
        , j ={' '}
      </tspan>
      <tspan x="634.164" y="223.938">
        ;&#10;
      </tspan>
      <tspan x="466" y="244.938" />
      <tspan x="466" y="265.938">
        {' '}
      </tspan>
      <tspan x="466" y="286.938">
        {' '}
      </tspan>
      <tspan x="524.857" y="286.938">
        {' '}
        (i ={' '}
      </tspan>
      <tspan x="583.715" y="286.938">
        ; i &#60; col; i++) {'{'}&#10;
      </tspan>
      <tspan x="466" y="307.938">
        {' '}
      </tspan>
      <tspan x="550.082" y="307.938">
        {' '}
        (board[row][i]) {'{'}&#10;
      </tspan>
      <tspan x="466" y="328.938">
        {' '}
      </tspan>
      <tspan x="617.348" y="328.938">
        {' '}
      </tspan>
      <tspan x="667.797" y="328.938">
        ;&#10;
      </tspan>
      <tspan x="466" y="349.938">
        {' '}
        {'}'}&#10;
      </tspan>
      <tspan x="466" y="370.938">
        {' '}
        {'}'}&#10;
      </tspan>
      <tspan x="466" y="391.938" />
      <tspan x="466" y="412.938">
        {' '}
        // Check upper diagonal on left side&#10;
      </tspan>
      <tspan x="466" y="433.938">
        {' '}
      </tspan>
      <tspan x="524.857" y="433.938">
        {' '}
        (i = row, j = col; i &#62;={' '}
      </tspan>
      <tspan x="743.471" y="433.938">
        {' '}
        &#38;&#38; j &#62;={' '}
      </tspan>
      <tspan x="827.553" y="433.938">
        ; i--, j--) {'{'}&#10;
      </tspan>
      <tspan x="466" y="454.938">
        {' '}
      </tspan>
      <tspan x="550.082" y="454.938">
        {' '}
        (board[i][j]) {'{'}&#10;
      </tspan>
      <tspan x="466" y="475.938">
        {' '}
      </tspan>
      <tspan x="617.348" y="475.938">
        {' '}
      </tspan>
      <tspan x="667.797" y="475.938">
        ;&#10;
      </tspan>
      <tspan x="466" y="496.938">
        {' '}
        {'}'}&#10;
      </tspan>
      <tspan x="466" y="517.938">
        {' '}
        {'}'}&#10;
      </tspan>
      <tspan x="466" y="538.938">
        {' '}
      </tspan>
      <tspan x="466" y="559.938">
        {' '}
      </tspan>
      <tspan x="524.857" y="559.938">
        {' '}
        (i = row, j = col; j &#62;={' '}
      </tspan>
      <tspan x="743.471" y="559.938">
        {' '}
        &#38;&#38; i &#60; n; i++, j--) {'{'}&#10;
      </tspan>
      <tspan x="466" y="580.938">
        {' '}
      </tspan>
      <tspan x="550.082" y="580.938">
        {' '}
        (board[i][j]) {'{'}&#10;
      </tspan>
      <tspan x="466" y="601.938">
        {' '}
      </tspan>
      <tspan x="617.348" y="601.938">
        {' '}
      </tspan>
      <tspan x="667.797" y="601.938">
        ;&#10;
      </tspan>
      <tspan x="466" y="622.938">
        {' '}
        {'}'}
      </tspan>
    </text>
    <text
      fill="#FD0054"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="466" y="160.938">
        template
      </tspan>
      <tspan x="466" y="181.938">
        bool
      </tspan>
      <tspan x="566.898" y="181.938">
        const
      </tspan>
      <tspan x="802.328" y="181.938">
        int
      </tspan>
      <tspan x="970.492" y="181.938">
        const int
      </tspan>
      <tspan x="566.898" y="202.938">
        const int
      </tspan>
      <tspan x="499.633" y="223.938">
        int
      </tspan>
      <tspan x="499.633" y="286.938">
        for
      </tspan>
      <tspan x="533.266" y="307.938">
        if
      </tspan>
      <tspan x="566.898" y="328.938">
        return
      </tspan>
      <tspan x="499.633" y="433.938">
        for
      </tspan>
      <tspan x="533.266" y="454.938">
        if
      </tspan>
      <tspan x="566.898" y="475.938">
        return
      </tspan>
      <tspan x="499.633" y="559.938">
        for
      </tspan>
      <tspan x="533.266" y="580.938">
        if
      </tspan>
      <tspan x="566.898" y="601.938">
        return
      </tspan>
    </text>
    <text
      fill="#001A9B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="550.082" y="160.938">
        size_t
      </tspan>
      <tspan x="566.898" y="223.938">
        0
      </tspan>
      <tspan x="625.756" y="223.938">
        0
      </tspan>
      <tspan x="575.307" y="286.938">
        0
      </tspan>
      <tspan x="625.756" y="328.938">
        false
      </tspan>
      <tspan x="735.062" y="433.938">
        0
      </tspan>
      <tspan x="819.145" y="433.938">
        0
      </tspan>
      <tspan x="625.756" y="475.938">
        false
      </tspan>
      <tspan x="735.062" y="559.938">
        0
      </tspan>
      <tspan x="625.756" y="601.938">
        false
      </tspan>
    </text>
    <text
      fill="#8152E0"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="508.041" y="181.938">
        isSafe
      </tspan>
    </text>
    <text
      fill="#798486"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="499.633" y="265.938">
        // Check this row on left side&#10;
      </tspan>
      <tspan x="499.633" y="538.938">
        // Check lower diagonal on left side&#10;
      </tspan>
    </text>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="14"
      fontWeight="600"
      letterSpacing="0em"
    >
      <tspan x="777.109" y="114.9">
        C++
      </tspan>
    </text>
    <path
      d="M392 429L212 429L212 348M212 348L221.625 359.625M212 348L202.375 359.625"
      stroke="#181A1B"
      strokeWidth="2"
    />
    <defs>
      <filter
        id="filter0_ddd_1112_9467"
        x="352"
        y="72"
        width="880"
        height="636"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1112_9467" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1112_9467"
          result="effect2_dropShadow_1112_9467"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="20" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1112_9467"
          result="effect3_dropShadow_1112_9467"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_1112_9467"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1112_9467"
        x1="336"
        y1="92"
        x2="77.7404"
        y2="103.189"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.248157" stopColor="#F14CFF" />
        <stop offset="0.873684" stopColor="#401AFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1112_9467"
        x1="316"
        y1="112"
        x2="99.3951"
        y2="121.384"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.248157" stopColor="#F14CFF" />
        <stop offset="0.873684" stopColor="#401AFF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1112_9467"
        x1="284"
        y1="168"
        x2="141.162"
        y2="247.866"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.202728" stopColor="#F14AFF" />
        <stop offset="0.888777" stopColor="#401AFF" />
      </linearGradient>
      <clipPath id="clip0_1112_9467">
        <rect width="66" height="72" fill="white" transform="translate(1102 556)" />
      </clipPath>
    </defs>
  </svg>
);

CPlusplus.propTypes = {
  className: PropTypes.string,
};

CPlusplus.defaultProps = {
  className: null,
};

export default CPlusplus;
